<template>
  <button
      data-test="button"
      :disabled="disabled"
      @click="$emit('click')"
      class="cursor-pointer text-18 mb-sm w-full h-xl text-whiteOverride rounded-lg border-none bg-bannerBlack hover:opacity-70 active:opacity-100 disabled:cursor-not-allowed disabled:opacity-25"
      :type="type"
      :class="{ 'bg-whiteOverride border-1 border-solid border-border text-black hover:bg-border hover:bg-opacity-100 active:bg-whiteOverride': secondary }">
    <b>{{ text }}</b>
  </button>
</template>

<script>
export default {
  name: 'PublicPageSubmitButton',
  props: {
    category: {
      type: String,
      default: 'primary',
    },
    type: {
      type: String,
      default: 'submit',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      required: true,
    },
    size: {
      type: String,
      default: 'full-width',
    },
  },
  computed: {
    secondary() {
      return this.category === 'secondary';
    },
    tertiary() {
      return this.category === 'tertiary';
    },
    small() {
      return this.size === 'small';
    },
  },
};
</script>
